import {
  SimpleEvent,
  useSimpleEventSubscription
} from '@passionware/simple-event';
import { ReactNode, useState } from 'react';
import {
  serverUnreachableEvent,
  type ServerFailurePayload
} from 'v5/platform/server-unreachable/serverUnreachableEvent';
import { ServerUnreachableScreen } from './ServerUnreachableScreen';

export type ServerUnreachableGateProps = {
  children: ReactNode;
  event?: SimpleEvent<ServerFailurePayload>;
};

export function ServerUnreachableGate({
  children,
  event = serverUnreachableEvent
}: ServerUnreachableGateProps) {
  const [payload, setPayload] = useState<ServerFailurePayload | null>(null);

  useSimpleEventSubscription(event.addListener, next => {
    setPayload(prev => prev ?? next);
  });

  if (payload) {
    return <ServerUnreachableScreen {...payload} />;
  }

  return children;
}
